import { useMedia } from 'react-use';

import { mobileMedia } from '@styles/variables';

export const useIsMobile = () => useMedia(mobileMedia);
